import { render, staticRenderFns } from "./dingGroup.vue?vue&type=template&id=3a8f8c9e&scoped=true&"
import script from "./dingGroup.vue?vue&type=script&lang=js&"
export * from "./dingGroup.vue?vue&type=script&lang=js&"
import style0 from "./dingGroup.vue?vue&type=style&index=0&id=3a8f8c9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f8c9e",
  null
  
)

export default component.exports